<template>
  <v-container
    tag="section"
  >
    <base-material-card
      color="coolrunner"
      icon="mdi-cash-multiple"
      inline
      class="px-5 py-3"
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          {{ $t('tracking') }}
        </div>
      </template>

      <v-row class="mx-0">
        <v-col cols="6">
          <filter-main
            :filter-options="filterOptions"
            :filter-actions="filterActions"
            :filter="filter"
            @set-filter="setFilter"
          />
        </v-col>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          class="ml-auto"
          :label="$t('search')"
          hide-details
          single-line
          style="max-width: 250px;"
          @blur="getDataFromApi"
          @keydown.enter="getDataFromApi"
        />
      </v-row>
      <v-divider class="my-3" />

      <v-data-table
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="loading"
        :footer-props="{
          itemsPerPageOptions: [10, 20, 50, 100]
        }"
        dense
        class="elevation-1"
      >
        <template v-slot:item.by_is_mapped="{ item }">
          <v-icon
            v-if="item.is_mapped"
            color="green"
          >
            check
          </v-icon>
          <v-icon
            v-else
            color="red"
          >
            not_interested
          </v-icon>
        </template>

        <template v-slot:item.action="{ item }">
          <v-row justify="end">
            <v-icon
              medium
              class="mr-5"

              color="green"
              @click="editItem(item)"
            >
              mdi-pencil
            </v-icon>
          </v-row>
        </template>

        <template v-slot:body.prepend>
          <filter-row
            :filter-options="filterOptions"
            :headers="headers"
            :filter="filter"
            @set-filter="setFilter"
          />
        </template>
      </v-data-table>
    </base-material-card>
    <v-dialog
      v-model="dialog"
      max-width="500px"
    >
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t('tracking') }}</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  dense
                  :label="$t('code')"
                  :value="editedItem.code"
                  disabled
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-select
                  v-model="editedItem.subcode"
                  :label="$t('subcode')"
                  dense
                  :items="subcodes"
                  @change="val => editedItem.code = possibleCodes.subcodes[val]"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="close"
          >
            {{ $t('cancel') }}
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="save"
          >
            {{ $t('save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
  import List from '@/mixins/List'

  export default {
    mixins: [List],
    data (vm) {
      return {
        dialog_send_mail: false,
        endpoint: 'tracking',
        name: 'tracking',
        headers: [
          {
            sortable: false,
            text: this.$t('mapped'),
            value: 'by_is_mapped',
          },
          {
            sortable: false,
            text: this.$t('carrier'),
            value: 'carrier',
            align: 'center',
          },
          {
            sortable: false,
            text: this.$t('carrier_code'),
            value: 'carrier_code',
            align: 'center',
          },
          {
            sortable: false,
            text: this.$t('code'),
            value: 'code',
            align: 'center',
          },
          {
            sortable: false,
            text: this.$t('subcode'),
            value: 'subcode',
            align: 'center',
          },
          {
            sortable: false,
            text: this.$t('title'),
            value: 'event_title',
          },
          {
            sortable: false,
            text: this.$t('created'),
            align: 'right',
            value: 'created_at',
          },
          { text: this.$t('actions'), value: 'action', sortable: false },
        ],
        filterOptions: {
          carrier: {
            label: this.$t('carrier'),
            type: 'multi',
            options: vm.$store.state.carriers,
            filter: [],
          },
          by_is_mapped: {
            label: this.$t('mapped'),
            type: 'single',
            options: [
              { slug: '1', label: this.$t('yes') },
              { slug: '0', label: this.$t('no') },
            ],
            filter: [],
          },
        },
        editedItem: {
          id: '',
          subcode: '',
        },
        defaultItem: {
          id: '',
          subcode: '',
        },
        possibleCodes: {},
      }
    },
    computed: {
      subcodes: function () {
        return this.$_.map(this.possibleCodes.subcodes, (code, key) => ({ text: key, value: key }))
      },
    },
    mounted: function () {
      this.getCodes()
    },
    methods: {
      getCodes () {
        this.$get(`${this.endpoint}/codes`).then(({ data }) => {
          this.possibleCodes = data
        })
      },
      updateCode (val) {
        this.editedItem.code = val
      },
    },
  }
</script>
